// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6bbea7c8","455":"2c14b195","977":"eab9564a"}[chunkId] + ".chunk.js";
};